module.exports = __webpack_public_path__ + "img/BkgUsuarios.b29dc009.jpg";